import { render, staticRenderFns } from "./ModalPreviewImg.vue?vue&type=template&id=7816dbae&scoped=true&"
import script from "./ModalPreviewImg.vue?vue&type=script&lang=js&"
export * from "./ModalPreviewImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7816dbae",
  null
  
)

export default component.exports